import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { DOMNode, mergeAttributes, Node } from '@tiptap/core';
import { DOMParser, Fragment } from '@tiptap/pm/model';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { KeyPointCalloutComponent } from './key-point-callout.component';
import { DEFAULT_KEY_POINT_CALLOUT_PROPS } from './key-point-callout.model';

export const KEY_POINT_CALLOUT_NODE_NAME = 'keyPointCallout';
const keyPointCalloutClassName = 'key-point-callout';

export const KeyPointCalloutExtension = (injector: Injector) => {
  return Node.create({
    name: KEY_POINT_CALLOUT_NODE_NAME,
    content: 'block+',
    group: 'block',
    defining: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        title: {
          default: DEFAULT_KEY_POINT_CALLOUT_PROPS.title,
        },
        color: {
          default: DEFAULT_KEY_POINT_CALLOUT_PROPS.color,
        },
        icon: {
          default: DEFAULT_KEY_POINT_CALLOUT_PROPS.icon,
        },
        custom_css: {
          default: '',
        },
        custom_style: {
          default: null,
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== keyPointCalloutClassName);
            return { class: `${keyPointCalloutClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${keyPointCalloutClassName}`,
          getContent(node: DOMNode, schema) {
            if (!(node instanceof Element)) {
              const paragraphType = schema.nodes['paragraph'];
              const textContent = node.textContent || '';
              // Create empty paragraph if no text content (empty text nodes are not allowed in ProseMirror)
              const paragraph = textContent
                ? paragraphType.create(null, schema.text(textContent))
                : paragraphType.create(null);
              return Fragment.from(paragraph);
            }

            const contentElement = node.querySelector('.key-point-callout-content') ?? node;

            // Parse the content using DOMParser to get proper block nodes
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = contentElement.innerHTML;
            const parsedContent = DOMParser.fromSchema(schema).parse(tempDiv);

            return parsedContent.content;
          },
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: keyPointCalloutClassName }, HTMLAttributes), 0];
    },

    addNodeView() {
      return AngularNodeViewRenderer(KeyPointCalloutComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
